import { Reveal, OceanTag } from "./kit";
import { OCEAN_TECH_CARDS, OIMG } from "../../data/oceanContent";

export default function OceanTechnology() {
  return (
    <section id="technology" data-testid="ocean-technology-section" className="relative py-24 lg:py-32 bg-oabyss/30">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <Reveal>
              <OceanTag index="04" label="Technology & Data" />
              <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-oseaglass leading-[0.95]">
                Instruments of <span className="text-oreef">observation</span>
              </h2>
              <p className="mt-6 text-base text-oseaglass/70 leading-relaxed">
                We distinguish raw satellite observations, derived indicators, underwater imagery and direct field
                measurements — and treat each for what it is.
              </p>
              <div className="mt-8 border border-oreef/20 overflow-hidden clip-corner">
                <img src={OIMG.satellite} alt="Satellite observing the ocean from orbit" className="w-full h-56 object-cover" />
              </div>
              <p className="mt-5 font-mono text-[10px] text-ogold tracking-[0.2em] leading-relaxed">
                NO INVENTED MODEL ACCURACY · NO FABRICATED WATER-QUALITY DATA · NO CLAIMED BATHYMETRIC SURVEYS
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {OCEAN_TECH_CARDS.map((t, i) => (
                <Reveal key={t.code} delay={0.04 * i}>
                  <div className="h-full border border-oreef/15 bg-onavy/50 p-6 hover:border-oreef/40 transition-colors duration-300" data-testid={`tech-card-${i}`}>
                    <div className="flex items-center gap-3">
                      <span className="font-mono text-xs text-ogold tracking-[0.15em] bg-ogold/10 border border-ogold/25 px-2 py-1">{t.code}</span>
                      <h3 className="font-display font-semibold text-lg text-oseaglass tracking-wide">{t.title}</h3>
                    </div>
                    <p className="mt-3 text-sm text-oseaglass/65 leading-relaxed">{t.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
